/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RadiologyReportTemplate from './radiology-report-template';
import RadiologyReportTemplateDetail from './radiology-report-template-detail';
import RadiologyReportTemplateUpdate from './radiology-report-template-update';
import RadiologyReportTemplateDeleteDialog from './radiology-report-template-delete-dialog';

const RadiologyReportTemplateRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RadiologyReportTemplate />} />
    <Route path="new" element={<RadiologyReportTemplateUpdate />} />
    <Route path=":id">
      <Route index element={<RadiologyReportTemplateDetail />} />
      <Route path="edit" element={<RadiologyReportTemplateUpdate />} />
      <Route path="delete" element={<RadiologyReportTemplateDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RadiologyReportTemplateRoutes;
